export const getFirstCharacters = ({ string = '', numberOfWords }) => {
    if (string.length <= numberOfWords) return string;
    return string.slice(0, numberOfWords);
};
